module.exports = __webpack_public_path__ + "img/mmp-logo.aee42371.png";